export function useHorseHelper() {
    function horseColorText(horse) {
        if (horse.colorName)
            return horse.colorName;
        return [
            horse.color?.name,
            horse.colorComplement ? `(${horse.colorComplement})` : null
        ]
            .filter(Boolean)
            .join(" ");
    }
    function horseBreedOrStudbookText(horse) {
        if (horse.breedingStudbookId)
            return horse.breedingStudbook.nameShort;
        return horse.breed?.name;
    }
    return {
        horseBreedOrStudbookText,
        horseColorText
    };
}
